module.exports = __webpack_public_path__ + "static/images/bg_card@2x.png";